import React from "react";
import { Row, Col } from 'reactstrap';
import './index.scss'
import { getFromLocalStorage } from '../../utils/Helpers';
import { SSO_auth_path } from '../../config';
import { Redirect } from 'react-router-dom';

const NoAccess = () => {
  const token = getFromLocalStorage("token");

  if (token?.step === 'dashborad') {
    return <Redirect to="/dashborad" />
  } else if (token?.step === 'register') {
    return <Redirect to="/register" />
  } else {
    let stingToConvert = '/verification'
    const urlParams = new URLSearchParams(window.location.search);
    const partnerToken = urlParams.get('token');
    if (partnerToken) {
      stingToConvert += '?token='+partnerToken;
    }
    let redirectUrl = btoa(stingToConvert)

    window.location.href = `${SSO_auth_path}&return_path=${redirectUrl}`;

    return <div></div>
  }
  return (
      <div className="session-inner-wrapper">
        <Row>
          <Col lg='9' md='12' sm='12' className="mx-auto">
            <div className="error-body text-center">
              <h2 className="error-msg">Oops.. </h2>
              <h2 className="error-msg">
                You don't have access to this page
              </h2>
            </div>
          </Col>
        </Row>
      </div>
  );
};
export default NoAccess
